module.exports = __webpack_public_path__ + "img/DW365-079.f9e0a36b.jpg";